import { selectAuthenticationStatus, setAuthenticationStatus, setAuthenticationUser } from "./slices";
import { API_STATUS, AUTH_STATUS } from "../../util/constants";
import { isUnauthenticated } from "../../util/functions";
import { fetchCurrentSession, redirectToLogIn } from "../../util/login";
import { authorizationApi } from "./api";
import { signOut } from "aws-amplify/auth";

export const buildLoginQuery = {
  queryFn: async (parameters = {}, { dispatch, getState }) => {
    const { redirectPath, doNotRedirect, force } = parameters;
    const status = selectAuthenticationStatus(getState())
    
    if(status === AUTH_STATUS.COGNITO_FAILURE && !force) {
      return {
        error: {
          status: API_STATUS.ERROR
        }
      }
    }
    const shouldRedirect = !doNotRedirect;

    try {
      const payload = await fetchCurrentSession();
      if (payload?.osuid) {
        dispatch(setAuthenticationUser(payload));
        return {
          data: payload,
        };
      } else if(shouldRedirect) {
        redirectToLogIn(redirectPath);
      }
      
      return { data: null };
    } catch (error) {
      if (isUnauthenticated(error) && shouldRedirect) {
          redirectToLogIn(redirectPath);
      } 
      return {
        data: {
          status: API_STATUS.IDLE
        }
      }
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      authorizationApi.endpoints.getAffiliations.matchPending,
      (state) => {
        state.status = API_STATUS.LOADING;
      }
    );
    builder.addMatcher(authorizationApi.endpoints.getAffiliations.matchFulfilled,
      (state) => {
        state.status = API_STATUS.SUCCESS;
      }
    );
    builder.addMatcher(authorizationApi.endpoints.getAffiliations.matchRejected,
      (state) => {
        state.status = API_STATUS.ERROR;
      }
    );
  }
};

export const buildLogoutQuery = {
  queryFn: async (parameters, { dispatch }) => {
    dispatch(setAuthenticationStatus(API_STATUS.LOADING))
    // signOut({ global: true }) clears the locally cached Cognito tokens (id/access/refresh in the
    // app's token storage) and revokes them server-side via GlobalSignOut. NOTE: this does not end
    // the upstream Cognito hosted-UI / Keycloak IdP session — that requires SAML single-logout
    // configured on the user pool (see docs), which is an identity-provider config concern, not a
    // client change.
    await signOut({
      global: true
    });
    dispatch(setAuthenticationStatus(AUTH_STATUS.CLEARED))
    return {
        data: {
            status: AUTH_STATUS.CLEARED
        }
    }
  },
};
